export default __webpack_public_path__ + "static/media/generalAwareness.d5c63b98.svg";